import { SuccessCloserLeaderboardEntry } from '../../services/api';

function normalize(value?: string): string {
  return (value || '').trim().toLowerCase();
}

export function filterLeaderboardByQuery(
  entries: SuccessCloserLeaderboardEntry[],
  query: string,
): SuccessCloserLeaderboardEntry[] {
  const normalizedQuery = normalize(query);
  if (!normalizedQuery) return entries;

  return entries.filter((entry) => {
    const projectName = normalize(entry.projectName);
    const agentName = normalize(entry.name);
    return projectName.includes(normalizedQuery) || agentName.includes(normalizedQuery);
  });
}

export function canPromptSelfTestimonial(
  entry: SuccessCloserLeaderboardEntry,
  currentUserCeaNumber?: string,
): boolean {
  if (entry.hasTestimonial) return false;
  return normalize(entry.ceaNumber) === normalize(currentUserCeaNumber);
}
